export const PIXEL_INIT_EVENT_KEY = '62ee5c6f-7517-4ec2-8a01-0cd99cee6caa';
